<template lang="pug">
table.gear-specs
  tbody
    tr.gear-specs-row
      td.gear-specs-column(colspan='2')
        h4 {{ __('Gear Specs', 'specs') }}
    tr.gear-specs-row(
      v-for='(gearSpec, index) in gearSpecs'
      :key='index'
    )
      td.gear-specs-column.gear-specs-label {{ __(gearSpec.label, 'specs') }}
      td.gear-specs-column.gear-specs-value(v-if="gearSpec.label === 'Brand' && brandUrl")
        router-link(:to="'/brands/'+brandUrl") {{ __(gearSpec.value, 'specs') }}
      td.gear-specs-column.gear-specs-value(v-else v-html="__(gearSpec.value, 'specs')")
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'
import getGearSpecAttributes from './gearspecAttributes'

type ProductLike = { attributes?: Record<string, unknown> } | Record<string, unknown>
type SimpleLike = { attributes?: Record<string, unknown> } | null
type SpecDef = { key: string; label: string }

const props = defineProps({
  product: {
    type    : Object as PropType<ProductLike>,
    default : () => ({}),
  },
  specs: {
    type    : Array as PropType<SpecDef[] | null>,
    default : null,
  },
  dynamic: {
    type    : Boolean,
    default : false,
  },
  selectedSimple: {
    type    : Object as PropType<ProductLike | null>,
    default : null,
  },
})

function mapValue(value: unknown) {
  const stringValue = String(value)
  if (stringValue === 'true') {
    return 'Yes'
  }
  if (stringValue === 'false') {
    return 'No'
  }

  return stringValue
}

const gearSpecs = computed(() => {
  const attrs = props.specs || (getGearSpecAttributes as unknown as (p: ProductLike) => SpecDef[])(props.product)

  return attrs
    .map(({ key, label }) => {
      const productAttrs = (props.product as ProductLike).attributes || {}
      const selectedAttrs = (props.selectedSimple as SimpleLike)?.attributes || {}

      let value = (selectedAttrs as Record<string, unknown>)[key]
      if (value === undefined) {
        value = (productAttrs as Record<string, unknown>)[key]
      }

      if (value !== undefined && value !== null && value !== '') {
        return { label, value: mapValue(value) }
      }

      return null
    })
    .filter((o) => Boolean(o)) as Array<{ label: string; value: string }>
})

const brandUrl = computed(() => {
  const attrs = (props.product as ProductLike).attributes || {}
  
  return (attrs as Record<string, unknown>).brand_url_key as string | undefined
})
</script>

<style lang='scss' scoped>
.gear-specs {
  background-color: $color-white;
  border-radius: 3px;
  padding: $space-s;
  font-family: $font-base;
}

.gear-specs-row {
  border-bottom: 1px solid $color-gray-light;
}

.gear-specs-column {
  text-align: left;
  padding: $space-xs 0;
}

.gear-specs-label {
  font-weight: bold;
  padding-right: $space-s;
}

h4 {
  margin-bottom: 0;
}
</style>
  